<div class="d-flex">
	<mat-card-title class="font-size-5 font-bold front-main-1">
		{{ title }}
	</mat-card-title>
</div>
<hr />
